import '../styles/main.scss';
import lazySizes from "lazysizes";
import './tools/lazybg';
import './tools/burger';
import './tools/faqs';
import './tools/slider';
import './tools/backToTop';
import './tools/search';
import './tools/timeline';
import './tools/galleryPopup';
import AOS from 'aos';


// init animation on scroll
AOS.init({
    duration: 1000
});

const thankYou = document.getElementById("thank-you");

if(thankYou) {
    console.log('thank you')
    thankYou.scrollIntoView({ behavior: 'smooth', block: 'start' });

}


